// src/pages/LearnReactPage.js
import React, { useState } from "react";
import Welcome from "../components/Basics/Welcome";
import Clock from "../components/Basics/Clock";

import "./BasicPage.css";

// CodeMirror for syntax highlighting in code blocks
import CodeMirror from "@uiw/react-codemirror";
import { StreamLanguage } from "@codemirror/language";
import { javascript } from "@codemirror/lang-javascript";
import { vscodeDark } from "@uiw/codemirror-theme-vscode";

function LearnBasicReactPage() {
  const [Code, setCode] = useState(`<p>Hello, world!</p>`);
  const [name, setName] = useState("Sara");

  const Code2 = `function Welcome(props) {
return (
<>
{/* This input changes the value of name whenever something is typed*/}
  <input
    type="text"
    value={props.name}
    onChange={(e) => props.setName(e.target.value)}

  />
  <p>Hello, {props.name}</p>
</>
);
}`;

  const Code3 = `class Welcome extends React.Component {
    render() {
      return <h1>Hello, {this.props.name}</h1>;
    }
  }`;
  return (
    <div className="BasicApp">
      <div className="Heading mb-4 ">
        <h1 className="text-3xl">Introduction to React 🌟</h1>
        <p>
          React is a popular JavaScript library for building user interfaces,
          especially single-page applications where you need a dynamic and
          interactive user experience. Developed by Facebook, React allows you
          to build reusable UI components.
        </p>
      </div>
      <h2 className="text-2xl">Basic Concepts 📚</h2>
      <hr className="w-[40%] mb-4  " />
      <h3 className="text-xl">JSX ✨</h3>
      <hr className="w-[40%] mb-2  " />
      <p>
        JSX stands for JavaScript XML. It allows you to write HTML in React.
      </p>
      <strong> Try Editing the element below:</strong>
      <div className="Code-Editor-Container">
        <pre>
          <code>{`const element = `}</code>
        </pre>

        <CodeMirror
          about="jsx"
          value={Code ? Code : "<p>Hello, world!</p>"} // Default value
          extensions={[javascript({ jsx: true })]}
          theme={vscodeDark}
          height="100%"
          //   options={{ readOnly: true }}
          onChange={(e) => setCode(e)}
          style={{
            scrollbarWidth: "none",
          }}
        />
      </div>
      <h4>Output:</h4>
      <div dangerouslySetInnerHTML={{ __html: Code }}></div>

      <br />
      <br />
      <br />
      <br />

      <h3 className="text-xl">Components</h3>
      <hr className="w-[40%] mb-2  " />
      <p>
        Components are the building blocks of a React application. They can be
        functional or class-based.
      </p>
      <h4>Functional Component</h4>

      <CodeMirror
        about="jsx"
        value={Code2} // Default value
        extensions={[javascript({ jsx: true })]}
        theme={vscodeDark}
        height="100%"
        options={{ readOnly: true }}
        readOnly="true"
        //   onChange={(e) => setCode(e)}
        style={{
          scrollbarWidth: "none",
        }}
      />
      <h4>Output:</h4>

      <Welcome name={name} setName={setName} />
      <br />
      <br />
      <br />
      <br />

      <h3 className="text-xl">Class Component</h3>
      <hr className="w-[40%] mb-2  " />

      <p>
        It works the same way as a functional component, but it uses a class to
        define the component.
      </p>
      <CodeMirror
        about="jsx"
        value={Code3} // Default value
        extensions={[javascript({ jsx: true })]}
        theme={vscodeDark}
        height="100%"
        options={{ readOnly: true }}
        readOnly="true"
        //   onChange={(e) => setCode(e)}
        style={{
          scrollbarWidth: "none",
        }}
      />
      <br />
      <br />
      <br />
      <br />
      <br />
      <h3 className="text-xl">State</h3>
      <hr className="w-[40%] mb-2  " />
      <p>
        State is used to manage data that can change over time and affect what
        is rendered.
      </p>
      <p>
        The Below Clock component uses state to update the time every second.
      </p>
      <Clock />
    </div>
  );
}

export default LearnBasicReactPage;
